import type { SpareCandidate } from './types'

// Immutable toggle for the multi-select set. Returns a new Set so React state
// updates trigger re-render.
export const toggleSelection = (
  current: Set<string>,
  id: string
): Set<string> => {
  const next = new Set(current)
  if (next.has(id)) {
    next.delete(id)
  } else {
    next.add(id)
  }
  return next
}

// The selection without the given ids (the players a send just asked).
export const withoutSelection = (
  current: Set<string>,
  ids: Iterable<string>
): Set<string> => {
  const next = new Set(current)
  for (const id of ids) {
    next.delete(id)
  }
  return next
}

/**
 * SN-8309 — the selected players a send reaches: those still listed, in list
 * order. A player asked meanwhile (asked players aren't listed) or hidden by a
 * filter drops out, so the count on the send button is exactly who it asks.
 */
export const sendableSelection = (
  candidates: readonly SpareCandidate[],
  selectedIds: Iterable<string>
): string[] => {
  const selected = new Set(selectedIds)

  return candidates
    .filter((candidate) => selected.has(candidate.id))
    .map((candidate) => candidate.id)
}
